/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import { defineMessages } from 'react-intl'

export const SET_APPLICANT = 'SET_APPLICANT'

export const APPLICANT_ADDITIONAL_SERVICES = [12874, 12012, 13738]

export const APPLICANT_CREATION_ACCESS_BLOCKED_ABA_CODE = [
    13368, 13450, 12069, 13363, 13366, 13370, 13384, 13525
]

export const messages = defineMessages({
  ENTITY_NAME_LABEL: {
    id: 'applicant.ENTITY_NAME_LABEL',
    defaultMessage: 'ENTITY_NAME_LABEL'
  },
  IDENTITY_NAME_LABEL: {
    id: 'applicant.IDENTITY_NAME_LABEL',
    defaultMessage: 'IDENTITY_NAME_LABEL'
  },
  USERNAME_LABEL: {
    id: 'applicant.USERNAME_LABEL',
    defaultMessage: 'USERNAME_LABEL'
  },
  APPLICANT_ABA_CODE_LABEL: {
    id: 'applicant.APPLICANT_ABA_CODE_LABEL',
    defaultMessage: 'APPLICANT_ABA_CODE_LABEL'
  },
  APPLICANT_IS_ACTIVE_LABEL: {
    id: 'applicant.APPLICANT_IS_ACTIVE_LABEL',
    defaultMessage: 'APPLICANT_IS_ACTIVE_LABEL'
  },
  USER_LAST_LOGIN_LABEL: {
    id: 'applicant.USER_LAST_LOGIN_LABEL',
    defaultMessage: 'USER_LAST_LOGIN_LABEL'
  },
  TOTAL_ELEMENTS: {
    id: 'applicant.TOTAL_ELEMENTS',
    defaultMessage: 'TOTAL_ELEMENTS'
  },
  SEARCH: {
    id: 'applicant.SEARCH',
    defaultMessage: 'SEARCH'
  },
  SEARCH_PLACEHOLDER: {
    id: 'applicant.SEARCH_PLACEHOLDER',
    defaultMessage: 'SEARCH_PLACEHOLDER'
  },
  ADD_APPLICANT: {
    id: 'applicant.ADD_APPLICANT',
    defaultMessage: 'ADD_APPLICANT'
  },
  SAVE: {
    id: 'applicant.SAVE',
    defaultMessage: 'SAVE'
  },
  EDIT: {
    id: 'applicant.EDIT',
    defaultMessage: 'EDIT'
  },
  BACK: {
    id: 'applicant.BACK',
    defaultMessage: 'BACK'
  },
  CANCEL: {
    id: 'applicant.CANCEL',
    defaultMessage: 'CANCEL'
  },
  ENTITY_LABEL: {
    id: 'applicant.ENTITY_LABEL',
    defaultMessage: 'ENTITY_LABEL'
  },
  NAME_LABEL: {
    id: 'applicant.NAME_LABEL',
    defaultMessage: 'NAME_LABEL'
  },
  ENTITY_ABA_CODE_LABEL: {
    id: 'applicant.ENTITY_ABA_CODE_LABEL',
    defaultMessage: 'ENTITY_ABA_CODE_LABEL'
  },
  ENTITY_PHONE_LABEL: {
    id: 'applicant.ENTITY_PHONE_LABEL',
    defaultMessage: 'ENTITY_PHONE_LABEL'
  },
  ENTITY_EMAIL_LABEL: {
    id: 'applicant.ENTITY_EMAIL_LABEL',
    defaultMessage: 'ENTITY_EMAIL_LABEL'
  },
  ENTITY_ADDRESS_LABEL: {
    id: 'applicant.ENTITY_ADDRESS_LABEL',
    defaultMessage: 'ENTITY_ADDRESS_LABEL'
  },
  IDENTITY_LABEL: {
    id: 'applicant.IDENTITY_LABEL',
    defaultMessage: 'IDENTITY_LABEL'
  },
  IDENTITY_FIRST_NAME_LABEL: {
    id: 'applicant.IDENTITY_FIRST_NAME_LABEL',
    defaultMessage: 'IDENTITY_FIRST_NAME_LABEL'
  },
  IDENTITY_LAST_NAME_LABEL: {
    id: 'applicant.IDENTITY_LAST_NAME_LABEL',
    defaultMessage: 'IDENTITY_LAST_NAME_LABEL'
  },
  IDENTITY_PHONE_LABEL: {
    id: 'applicant.IDENTITY_PHONE_LABEL',
    defaultMessage: 'IDENTITY_PHONE_LABEL'
  },
  IDENTITY_EMAIL_LABEL: {
    id: 'applicant.IDENTITY_EMAIL_LABEL',
    defaultMessage: 'IDENTITY_EMAIL_LABEL'
  },
  IDENTITY_FUNCTION_LABEL: {
    id: 'applicant.IDENTITY_FUNCTION_LABEL',
    defaultMessage: 'IDENTITY_FUNCTION_LABEL'
  },
  USER_LABEL: {
    id: 'applicant.USER_LABEL',
    defaultMessage: 'USER_LABEL'
  },
  USER_USERNAME_LABEL: {
    id: 'applicant.USER_USERNAME_LABEL',
    defaultMessage: 'USER_USERNAME_LABEL'
  },
  USER_EMAIL_LABEL: {
    id: 'applicant.USER_EMAIL_LABEL',
    defaultMessage: 'USER_EMAIL_LABEL'
  },
  USER_IS_ACTIVE_LABEL: {
    id: 'applicant.USER_IS_ACTIVE_LABEL',
    defaultMessage: 'USER_IS_ACTIVE_LABEL'
  },
  USER_TYPE_VIEW_LABEL: {
    id: 'applicant.USER_TYPE_VIEW_LABEL',
    defaultMessage: 'USER_TYPE_VIEW_LABEL'
  },
  SAVE_ALERT: {
    id: 'applicant.SAVE_ALERT',
    defaultMessage: 'SAVE_ALERT'
  },
  CLOSE_ALERT: {
    id: 'applicant.CLOSE_ALERT',
    defaultMessage: 'CLOSE_ALERT'
  },
  CONFIRM_ALERT: {
    id: 'applicant.CONFIRM_ALERT',
    defaultMessage: 'CONFIRM_ALERT'
  },
  ALERT_MESSAGE1: {
    id: 'applicant.ALERT_MESSAGE1',
    defaultMessage: 'ALERT_MESSAGE1'
  },
  ALERT_MESSAGE2: {
    id: 'applicant.ALERT_MESSAGE2',
    defaultMessage: 'ALERT_MESSAGE2'
  },
  APPLICANT_ADMIN_REMARKS_MESSAGE: {
    id: 'applicant.APPLICANT_ADMIN_REMARKS_MESSAGE',
    defaultMessage: 'APPLICANT_ADMIN_REMARKS_MESSAGE'
  }
})



// WEBPACK FOOTER //
// ./src/constants/Applicant.js